module.exports = __webpack_public_path__ + "static/media/diagram_06.1b21be6e.svg";